module.exports = __webpack_public_path__ + "static/img/rat.abbcf54.png";